import React from "react";
import CarMasterData from "./carMasterData";

const TypesList = () => {
  const tabeName = "carSafetyFeatures";

  return (
    <>
      <CarMasterData tabeName={tabeName} />
    </>
  );
};

export default TypesList;
